export default "__VITE_ASSET__uYUevRYP__"